import { Helmet } from 'react-helmet';
export { Helmet } from 'react-helmet';
import React, { Component, useRef } from 'react';
import * as rdd from 'react-device-detect';
import { CloseCircleFilled, WarningFilled, InfoCircleFilled, NodeIndexOutlined, SearchOutlined, ShopOutlined, MessageOutlined, SettingOutlined, UserOutlined, SyncOutlined, MenuOutlined, CaretDownOutlined } from '@ant-design/icons';
import { Result, Spin, Avatar as Avatar$1, Input, Modal, List, Empty, Menu, Dropdown, Badge, Breadcrumb as Breadcrumb$1, Button, Table as Table$1, Timeline as Timeline$1, Card } from 'antd';
import _debounce from 'lodash/debounce';
import _isFunction from 'lodash/isFunction';
import memoize from 'memoizee';
import _omitObjKeys from 'lodash/omit';
import objDeepMixin from 'mixin-deep';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

var HeaderBar = /*#__PURE__*/function (_Component) {
  _inherits(HeaderBar, _Component);

  var _super = _createSuper(HeaderBar);

  function HeaderBar() {
    _classCallCheck(this, HeaderBar);

    return _super.apply(this, arguments);
  }

  _createClass(HeaderBar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          subTitle = _this$props.subTitle,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style;
      return /*#__PURE__*/React.createElement("div", {
        className: "HeaderBar",
        style: style
      }, /*#__PURE__*/React.createElement("div", {
        className: "HeaderBar__title"
      }, title), /*#__PURE__*/React.createElement("div", {
        className: "HeaderBar__subTitle"
      }, subTitle));
    }
  }]);

  return HeaderBar;
}(Component);

function HelloWorld() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$text = props.text,
      text = _props$text === void 0 ? 'Hello World' : _props$text;
  return /*#__PURE__*/React.createElement("h1", {
    className: "HelloWorld"
  }, text);
}

var userAgentDetails$2 = {
  isMobile: rdd.isMobile,
  // Returns true if device type is mobile or tablet.
  isMobileOnly: rdd.isMobileOnly,
  // Returns true if device type is mobile.
  isTablet: rdd.isTablet,
  isDesktop: rdd.isDesktop,
  isIOS: rdd.isIOS,
  isAndroid: rdd.isAndroid,
  isWinPhone: rdd.isWinPhone,
  osName: rdd.osName,
  browserName: rdd.browserName,
  mobileVendor: rdd.mobileVendor,
  mobileModel: rdd.mobileModel,
  deviceType: rdd.deviceType,
  // Custom Data
  isMobileDevice: rdd.isMobileOnly // Returns true if device type is mobile.

};
var deviceDetectionUtils = {
  userAgentDetails: userAgentDetails$2
};

var userAgentDetails$1 = deviceDetectionUtils.userAgentDetails;
var isMobileDevice$1 = userAgentDetails$1.isMobileDevice;
var defaultContextValues = {
  contextState: {
    dashboardLayoutBreadcrumbRoutes: [],
    // Track what should be rendered on direct Breadcrumb inside the <DashboardLayout.MainContent/>
    currentViewportData: {} // Track details about current viewport width, height, etc...

  },
  contextActions: {
    updateDashboardLayoutBreadcrumbRoutes: function updateDashboardLayoutBreadcrumbRoutes() {},
    updateCurrentViewportData: function updateCurrentViewportData() {}
  }
}; // Context Itself.

var EcouiContext = /*#__PURE__*/React.createContext(defaultContextValues); // This should be used by user on their react project and wrap <App/> with it. Similar to ReactRouter.

var EcouiProvider = /*#__PURE__*/function (_Component) {
  _inherits(EcouiProvider, _Component);

  var _super = _createSuper(EcouiProvider);

  function EcouiProvider(props) {
    var _this;

    _classCallCheck(this, EcouiProvider);

    _this = _super.call(this, props);
    _this.state = _objectSpread2({}, defaultContextValues.contextState);
    return _this;
  }

  _createClass(EcouiProvider, [{
    key: "updateDashboardLayoutBreadcrumbRoutes",
    value: function updateDashboardLayoutBreadcrumbRoutes() {
      var dashboardRoutes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.setState({
        dashboardLayoutBreadcrumbRoutes: dashboardRoutes
      });
    }
  }, {
    key: "updateCurrentViewportData",
    value: function updateCurrentViewportData() {
      var viewportData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.setState({
        currentViewportData: viewportData
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          _this$props$appSettin = _this$props.appSettings,
          appSettings = _this$props$appSettin === void 0 ? {} : _this$props$appSettin;
      var _appSettings$disableA = appSettings.disableAppZoom,
          disableAppZoom = _appSettings$disableA === void 0 ? true : _appSettings$disableA; // This is what get by any React Component/Element that consume our "EcouiContext"

      var providerValue = {
        contextState: this.state,
        contextActions: {
          updateDashboardLayoutBreadcrumbRoutes: function updateDashboardLayoutBreadcrumbRoutes() {
            return _this2.updateDashboardLayoutBreadcrumbRoutes.apply(_this2, arguments);
          },
          updateCurrentViewportData: function updateCurrentViewportData() {
            return _this2.updateCurrentViewportData.apply(_this2, arguments);
          }
        }
      };
      return /*#__PURE__*/React.createElement(EcouiContext.Provider, {
        value: providerValue
      }, /*#__PURE__*/React.createElement(Helmet, null, disableAppZoom && /*#__PURE__*/React.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1, maximum-scale=1"
      })), /*#__PURE__*/React.createElement("div", {
        className: "ECOUI-PROVIDER ".concat(isMobileDevice$1 ? 'ECOUI-MOBILE-DEVICE' : '' // This class is used in multiple places to apply/override style when user is on Mobile Device. (Regardless of Resolution)
        , "\n\t\t\t\t")
      }, children));
    }
  }]);

  return EcouiProvider;
}(Component); // This can be used to directly access Context from anywhere inside "<EcouiContext.Provider/>"
// USAGE TIP : Direct children must be a function to access context. Then within that function return Components you need.
// OTHER WAYS : We have also created a HOC to consume this context. Check 'withEcouiContext()' HOC in './components/hoc/withContext'. Also in class components we can do 'xxx.contextType=EcouiContext" to directly access it.

function EcouiConsumer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(EcouiContext.Consumer, null, function (context) {
    if (context === undefined) {
      throw new Error('EcouiConsumer must be used within a EcouiProvider');
    }

    return children(context);
  });
}

function withEcouiContext(WrappedComponent) {
  return function (props) {
    return /*#__PURE__*/React.createElement(EcouiConsumer, null, function (context) {
      var contextState = context.contextState,
          contextActions = context.contextActions;
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
        contextState: contextState,
        contextActions: contextActions
      }, props));
    });
  };
}

//        By the way this viewport related data are collected/handled in 'DashboardLayout' and do update in context. So in here we access those data from that context values.

function withViewportData(WrappedComponent) {
  return function (props) {
    return /*#__PURE__*/React.createElement(EcouiConsumer, null, function (context) {
      var contextState = context.contextState;
      var currentViewportData = contextState.currentViewportData;
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
        currentViewportData: currentViewportData
      }, props));
    });
  };
}

var defaultTypeConfigs = {
  loading: {
    status: 'info',
    title: '',
    subTitle: '',
    icon: /*#__PURE__*/React.createElement(Spin, null),
    extra: ''
  },
  error: {
    status: 'error',
    title: '',
    subTitle: 'Error Occurred. Please Try Again.',
    icon: /*#__PURE__*/React.createElement(CloseCircleFilled, null),
    extra: ''
  },
  warning: {
    status: 'warning',
    title: '',
    subTitle: 'Warning.',
    icon: /*#__PURE__*/React.createElement(WarningFilled, null),
    extra: ''
  },
  info: {
    status: 'info',
    title: '',
    subTitle: '',
    icon: /*#__PURE__*/React.createElement(InfoCircleFilled, null),
    extra: ''
  },
  empty: {
    status: 'info',
    title: '',
    subTitle: '',
    icon: /*#__PURE__*/React.createElement(NodeIndexOutlined, {
      style: {
        color: 'gray'
      }
    }),
    extra: ''
  }
};

var LoaderView = /*#__PURE__*/function (_Component) {
  _inherits(LoaderView, _Component);

  var _super = _createSuper(LoaderView);

  function LoaderView() {
    _classCallCheck(this, LoaderView);

    return _super.apply(this, arguments);
  }

  _createClass(LoaderView, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$type = _this$props.type,
          type = _this$props$type === void 0 ? '' : _this$props$type,
          _this$props$typeConfi = _this$props.typeConfigs,
          typeConfigs = _this$props$typeConfi === void 0 ? {} : _this$props$typeConfi,
          isLoading = _this$props.isLoading,
          isError = _this$props.isError,
          isWarning = _this$props.isWarning,
          isEmpty = _this$props.isEmpty,
          isInfo = _this$props.isInfo;
      var currentType = type;

      switch (true) {
        case isLoading:
          {
            //  NOTE : 'isLoading' take precedence if passed.
            currentType = 'loading';
            break;
          }

        case Boolean(isError):
          {
            currentType = 'error';
            break;
          }

        case Boolean(isWarning):
          {
            currentType = 'warning';
            break;
          }

        case isEmpty:
          {
            currentType = 'empty';
            break;
          }

        case isInfo:
          {
            currentType = 'info';
            break;
          }
      }

      if (!currentType) {
        return null;
      }

      var currentTypeDefaultValue = defaultTypeConfigs[currentType] || {};
      var currentTypePassedValues = typeConfigs[currentType] || {};

      var fullConfigProps = _objectSpread2(_objectSpread2({}, currentTypeDefaultValue), currentTypePassedValues);

      return /*#__PURE__*/React.createElement("div", {
        className: "LoaderView"
      }, /*#__PURE__*/React.createElement(Result, fullConfigProps));
    }
  }]);

  return LoaderView;
}(Component);

var img = "data:image/png;base64,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";

var Avatar = /*#__PURE__*/function (_Component) {
  _inherits(Avatar, _Component);

  var _super = _createSuper(Avatar);

  function Avatar() {
    _classCallCheck(this, Avatar);

    return _super.apply(this, arguments);
  }

  _createClass(Avatar, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "Avatar"
      }, /*#__PURE__*/React.createElement(Avatar$1, this.props));
    }
  }]);

  return Avatar;
}(Component);

var SearchBox = /*#__PURE__*/function (_Component) {
  _inherits(SearchBox, _Component);

  var _super = _createSuper(SearchBox);

  function SearchBox() {
    _classCallCheck(this, SearchBox);

    return _super.apply(this, arguments);
  }

  _createClass(SearchBox, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "SearchBox"
      }, /*#__PURE__*/React.createElement(Input, {
        size: "large",
        placeholder: "Search",
        prefix: /*#__PURE__*/React.createElement(SearchOutlined, null)
      }));
    }
  }]);

  return SearchBox;
}(Component);

var appList = [{
  Name: 'Web Order',
  AboutApp: 'This app is for web ordering for Restaurants',
  AppImage: 'https://cdn.neurolage.com/apps/WebOrder.png',
  IntegrationURL: 'https://aharamuthal.com'
}, {
  Name: 'NeutriPOS',
  AboutApp: 'This app is for Restaurants',
  AppImage: 'https://cdn.neurolage.com/apps/NeutriPOS.png',
  IntegrationURL: 'https://neutripos.witmeg.com'
}, {
  Name: 'ElectriPOS',
  AboutApp: 'This app is for Retail',
  AppImage: 'https://cdn.neurolage.com/apps/ElectriPOS.png',
  IntegrationURL: 'https://electripos.witmeg.com'
}, {
  Name: 'Neurolage',
  AboutApp: 'This app is for Whole Sale',
  AppImage: 'https://cdn.neurolage.com/apps/WholeSale.png',
  IntegrationURL: 'https://neurolage.witmeg.com'
}, {
  Name: 'TempleTrack',
  AboutApp: 'This app is for Temples',
  AppImage: 'https://cdn.neurolage.com/apps/TempleTrack.png',
  IntegrationURL: 'https://templetrack.witmeg.com'
}, {
  Name: 'Retailpacx',
  AboutApp: 'This app is for E Commerce',
  AppImage: 'https://cdn.neurolage.com/apps/RetailPacx.png',
  IntegrationURL: 'https://retailpacx.witmeg.com'
}, {
  Name: 'Loyalty',
  AboutApp: 'This app is for Everyone',
  AppImage: 'https://cdn.neurolage.com/apps/Loyalty.png',
  IntegrationURL: 'https://loyalty.witmeg.com'
}];

var AppChangeModal = /*#__PURE__*/function (_Component) {
  _inherits(AppChangeModal, _Component);

  var _super = _createSuper(AppChangeModal);

  function AppChangeModal() {
    _classCallCheck(this, AppChangeModal);

    return _super.apply(this, arguments);
  }

  _createClass(AppChangeModal, [{
    key: "render",
    value: function render() {
      var _this$props$modalProp = this.props.modalProps,
          modalProps = _this$props$modalProp === void 0 ? {} : _this$props$modalProp;
      return /*#__PURE__*/React.createElement(Modal, modalProps, /*#__PURE__*/React.createElement("div", {
        className: "AppChangeModal"
      }, /*#__PURE__*/React.createElement(List, {
        itemLayout: "horizontal",
        dataSource: appList,
        renderItem: function renderItem(item) {
          return /*#__PURE__*/React.createElement(List.Item, {
            actions: [/*#__PURE__*/React.createElement("a", {
              href: item.IntegrationURL
            }, "GO")]
          }, /*#__PURE__*/React.createElement(List.Item.Meta, {
            avatar: /*#__PURE__*/React.createElement(Avatar$1, {
              src: item.AppImage,
              shape: "square",
              size: "large"
            }),
            title: /*#__PURE__*/React.createElement("a", {
              href: "https://ant.design"
            }, item.Name),
            description: item.AboutApp
          }));
        }
      })));
    }
  }]);

  return AppChangeModal;
}(Component);

var PopupListMenu = /*#__PURE__*/function (_Component) {
  _inherits(PopupListMenu, _Component);

  var _super = _createSuper(PopupListMenu);

  function PopupListMenu() {
    _classCallCheck(this, PopupListMenu);

    return _super.apply(this, arguments);
  }

  _createClass(PopupListMenu, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$emptyMess = _this$props.emptyMessage,
          emptyMessage = _this$props$emptyMess === void 0 ? 'No Items' : _this$props$emptyMess,
          _this$props$backgroun = _this$props.backgroundIcon,
          backgroundIcon = _this$props$backgroun === void 0 ? function () {} : _this$props$backgroun,
          _this$props$menuTop = _this$props.menuTop,
          menuTop = _this$props$menuTop === void 0 ? '' : _this$props$menuTop,
          _this$props$listItems = _this$props.listItems,
          listItems = _this$props$listItems === void 0 ? [
        /**
             Obj. Structure should match to Renderer Function. Ex:-
                {
        			avatarValue: 'AB',
                  title: 'Organization Added',
                  subtitle: 'PizzaHut Added to Org Registry.',
        			onClick: () => {},
                }
             */
      ] : _this$props$listItems;
      return /*#__PURE__*/React.createElement("div", {
        className: "PopupListMenu"
      }, /*#__PURE__*/React.createElement("div", {
        className: "PopupListMenu__backgroundIcon"
      }, backgroundIcon), menuTop && /*#__PURE__*/React.createElement("div", {
        className: "PopupListMenu__top"
      }, menuTop), /*#__PURE__*/React.createElement("div", {
        className: "PopupListMenu__menu"
      }, /*#__PURE__*/React.createElement(List, {
        size: "small",
        itemLayout: "horizontal",
        locale: {
          emptyText: /*#__PURE__*/React.createElement(Empty, {
            image: Empty.PRESENTED_IMAGE_SIMPLE,
            description: emptyMessage
          })
        },
        dataSource: listItems,
        renderItem: function renderItem(item) {
          return /*#__PURE__*/React.createElement(List.Item, {
            onClick: item.onClick
          }, /*#__PURE__*/React.createElement(List.Item.Meta, {
            avatar: item.avatarValue ? /*#__PURE__*/React.createElement(Avatar, null, item.avatarValue) : '',
            title: item.title,
            description: item.subtitle
          }));
        }
      })));
    }
  }]);

  return PopupListMenu;
}(Component);

var LocationSelectorMenu = /*#__PURE__*/function (_Component) {
  _inherits(LocationSelectorMenu, _Component);

  var _super = _createSuper(LocationSelectorMenu);

  function LocationSelectorMenu() {
    _classCallCheck(this, LocationSelectorMenu);

    return _super.apply(this, arguments);
  }

  _createClass(LocationSelectorMenu, [{
    key: "render",
    value: function render() {
      var _this$props$listItems = this.props.listItems,
          listItems = _this$props$listItems === void 0 ? [] : _this$props$listItems;
      return /*#__PURE__*/React.createElement("div", {
        className: "LocationSelectorMenu"
      }, /*#__PURE__*/React.createElement(PopupListMenu, {
        emptyMessage: "No Locations Available.",
        backgroundIcon: /*#__PURE__*/React.createElement(ShopOutlined, null),
        listItems: listItems
      }));
    }
  }]);

  return LocationSelectorMenu;
}(Component);

var MessagesMenu = /*#__PURE__*/function (_Component) {
  _inherits(MessagesMenu, _Component);

  var _super = _createSuper(MessagesMenu);

  function MessagesMenu() {
    _classCallCheck(this, MessagesMenu);

    return _super.apply(this, arguments);
  }

  _createClass(MessagesMenu, [{
    key: "render",
    value: function render() {
      var _this$props$messageLi = this.props.messageList,
          messageList = _this$props$messageLi === void 0 ? [] : _this$props$messageLi;
      return /*#__PURE__*/React.createElement("div", {
        className: "MessageMenu"
      }, /*#__PURE__*/React.createElement(PopupListMenu, {
        emptyMessage: "No Notifications/Messages",
        backgroundIcon: /*#__PURE__*/React.createElement(MessageOutlined, null),
        listItems: messageList
      }));
    }
  }]);

  return MessagesMenu;
}(Component);

var PopupMenu = /*#__PURE__*/function (_Component) {
  _inherits(PopupMenu, _Component);

  var _super = _createSuper(PopupMenu);

  function PopupMenu() {
    _classCallCheck(this, PopupMenu);

    return _super.apply(this, arguments);
  }

  _createClass(PopupMenu, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$backgroun = _this$props.backgroundIcon,
          backgroundIcon = _this$props$backgroun === void 0 ? function () {} : _this$props$backgroun,
          _this$props$menuTop = _this$props.menuTop,
          menuTop = _this$props$menuTop === void 0 ? '' : _this$props$menuTop,
          _this$props$menuItems = _this$props.menuItems,
          menuItems = _this$props$menuItems === void 0 ? [
        /**
             Obj. Structure Ex:-
                {
                  menuTitle: 'User Profile',
                  menuIcon: <UserProfileIcon/>,
                  onClick: () => {},
                }
             */
      ] : _this$props$menuItems;
      return /*#__PURE__*/React.createElement("div", {
        className: "PopupMenu"
      }, /*#__PURE__*/React.createElement("div", {
        className: "PopupMenu__backgroundIcon"
      }, backgroundIcon), menuTop && /*#__PURE__*/React.createElement("div", {
        className: "PopupMenu__top"
      }, menuTop), /*#__PURE__*/React.createElement("div", {
        className: "PopupMenu__menu"
      }, /*#__PURE__*/React.createElement(Menu, null, menuItems.map(function (menuItem, index) {
        return /*#__PURE__*/React.createElement(Menu.Item, {
          key: index,
          icon: menuItem.menuIcon,
          onClick: menuItem.onClick
        }, menuItem.menuTitle);
      }))));
    }
  }]);

  return PopupMenu;
}(Component);

var SettingsMenu = /*#__PURE__*/function (_Component) {
  _inherits(SettingsMenu, _Component);

  var _super = _createSuper(SettingsMenu);

  function SettingsMenu() {
    _classCallCheck(this, SettingsMenu);

    return _super.apply(this, arguments);
  }

  _createClass(SettingsMenu, [{
    key: "render",
    value: function render() {
      var _this$props$menuItems = this.props.menuItems,
          menuItems = _this$props$menuItems === void 0 ? [] : _this$props$menuItems;
      return /*#__PURE__*/React.createElement("div", {
        className: "SettingsMenu"
      }, /*#__PURE__*/React.createElement(PopupMenu, {
        backgroundIcon: /*#__PURE__*/React.createElement(SettingOutlined, null),
        menuItems: menuItems
      }));
    }
  }]);

  return SettingsMenu;
}(Component);

var UserMenu = /*#__PURE__*/function (_Component) {
  _inherits(UserMenu, _Component);

  var _super = _createSuper(UserMenu);

  function UserMenu() {
    _classCallCheck(this, UserMenu);

    return _super.apply(this, arguments);
  }

  _createClass(UserMenu, [{
    key: "generateMenuTop",
    value: function generateMenuTop() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _data$avatarValue = data.avatarValue,
          avatarValue = _data$avatarValue === void 0 ? '' : _data$avatarValue,
          _data$avatarIcon = data.avatarIcon,
          avatarIcon = _data$avatarIcon === void 0 ? '' : _data$avatarIcon,
          _data$title = data.title,
          title = _data$title === void 0 ? '' : _data$title,
          _data$subtitle = data.subtitle,
          subtitle = _data$subtitle === void 0 ? '' : _data$subtitle; // When "Title" is not provided we don't render menu top part.

      if (!title) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "UserMenu__top"
      }, avatarValue !== '' ? /*#__PURE__*/React.createElement(Avatar, null, avatarValue) : /*#__PURE__*/React.createElement(Avatar, {
        icon: avatarIcon || /*#__PURE__*/React.createElement(UserOutlined, null)
      }), /*#__PURE__*/React.createElement("div", {
        className: "UserMenu__top__details"
      }, /*#__PURE__*/React.createElement("div", {
        className: "UserMenu__top__details__title"
      }, title), /*#__PURE__*/React.createElement("div", {
        className: "UserMenu__top__details__subTitle"
      }, subtitle)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$avatarVal = _this$props.avatarValue,
          avatarValue = _this$props$avatarVal === void 0 ? '' : _this$props$avatarVal,
          _this$props$avatarIco = _this$props.avatarIcon,
          avatarIcon = _this$props$avatarIco === void 0 ? '' : _this$props$avatarIco,
          _this$props$title = _this$props.title,
          title = _this$props$title === void 0 ? '' : _this$props$title,
          _this$props$subtitle = _this$props.subtitle,
          subtitle = _this$props$subtitle === void 0 ? '' : _this$props$subtitle,
          _this$props$menuItems = _this$props.menuItems,
          menuItems = _this$props$menuItems === void 0 ? [] : _this$props$menuItems;
      return /*#__PURE__*/React.createElement("div", {
        className: "UserMenu"
      }, /*#__PURE__*/React.createElement(PopupMenu, {
        backgroundIcon: /*#__PURE__*/React.createElement(UserOutlined, null),
        menuTop: this.generateMenuTop({
          avatarValue: avatarValue,
          avatarIcon: avatarIcon,
          title: title,
          subtitle: subtitle
        }),
        menuItems: menuItems
      }));
    }
  }]);

  return UserMenu;
}(Component);

var AppBar = /*#__PURE__*/function (_React$Component) {
  _inherits(AppBar, _React$Component);

  var _super = _createSuper(AppBar);

  function AppBar(props) {
    var _this;

    _classCallCheck(this, AppBar);

    _this = _super.call(this, props);
    _this.state = {
      isAppChangeModalVisible: false
    };
    return _this;
  }

  _createClass(AppBar, [{
    key: "toggleAppChangeModal",
    value: function toggleAppChangeModal() {
      var isAppChangeModalVisible = this.state.isAppChangeModalVisible;
      this.setState({
        isAppChangeModalVisible: !isAppChangeModalVisible
      });
    }
  }, {
    key: "updateAppBarElementHeightInCSSVariable",
    value: function updateAppBarElementHeightInCSSVariable() {
      // Updating CSS Variable that determine how much below content need to be padded. (Because AppBar is Fixed on Top.)
      // Especially when Mobile Menu View and Mobile Menu is Opened.
      var rootElement = document.documentElement;
      var appBarElement = document.querySelector('.AppBar--mobileMenuOpen') || {};
      var appBarHeight = appBarElement.offsetHeight;

      if (appBarHeight) {
        rootElement.style.setProperty('--appBarHeight', "".concat(appBarHeight, "px"));
      } else {
        // Reversing to default value when menu is closed. (This value should be synced with initial CSS variable value )
        rootElement.style.setProperty('--appBarHeight', "".concat(55, "px"));
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateAppBarElementHeightInCSSVariable();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var isAppChangeModalVisible = this.state.isAppChangeModalVisible;
      var _this$props = this.props,
          _this$props$toggleMob = _this$props.toggleMobileMenu,
          toggleMobileMenu = _this$props$toggleMob === void 0 ? function () {} : _this$props$toggleMob,
          _this$props$isMobileM = _this$props.isMobileMenuOpen,
          isMobileMenuOpen = _this$props$isMobileM === void 0 ? false : _this$props$isMobileM,
          _this$props$isMobileV = _this$props.isMobileViewport,
          isMobileViewport = _this$props$isMobileV === void 0 ? false : _this$props$isMobileV,
          _this$props$isMobileD = _this$props.isMobileDevice,
          isMobileDevice = _this$props$isMobileD === void 0 ? false : _this$props$isMobileD,
          _this$props$appTitleP = _this$props.appTitleProps,
          appTitleProps = _this$props$appTitleP === void 0 ? {} : _this$props$appTitleP,
          _this$props$pageTitle = _this$props.pageTitleProps,
          pageTitleProps = _this$props$pageTitle === void 0 ? {} : _this$props$pageTitle,
          _this$props$locationS = _this$props.locationSelectorProps,
          locationSelectorProps = _this$props$locationS === void 0 ? {} : _this$props$locationS,
          _this$props$userMenuP = _this$props.userMenuProps,
          userMenuProps = _this$props$userMenuP === void 0 ? {} : _this$props$userMenuP,
          _this$props$settingsM = _this$props.settingsMenuProps,
          settingsMenuProps = _this$props$settingsM === void 0 ? {} : _this$props$settingsM,
          _this$props$messageMe = _this$props.messageMenuProps,
          messageMenuProps = _this$props$messageMe === void 0 ? {} : _this$props$messageMe;
      var _appTitleProps$appTit = appTitleProps.appTitle,
          appTitle = _appTitleProps$appTit === void 0 ? 'ECOLOGITAL' : _appTitleProps$appTit,
          _appTitleProps$appSub = appTitleProps.appSubtitle,
          appSubtitle = _appTitleProps$appSub === void 0 ? '' : _appTitleProps$appSub,
          _appTitleProps$appLog = appTitleProps.appLogoUrl,
          appLogoUrl = _appTitleProps$appLog === void 0 ? img : _appTitleProps$appLog,
          _appTitleProps$onClic = appTitleProps.onClick,
          onAppTitleSectionClicked = _appTitleProps$onClic === void 0 ? function () {} : _appTitleProps$onClic;
      var _pageTitleProps$pageT = pageTitleProps.pageTitle,
          pageTitle = _pageTitleProps$pageT === void 0 ? '' : _pageTitleProps$pageT,
          _pageTitleProps$pageS = pageTitleProps.pageSubtitle,
          pageSubtitle = _pageTitleProps$pageS === void 0 ? '' : _pageTitleProps$pageS,
          _pageTitleProps$onCli = pageTitleProps.onClick,
          onPageTitleSectionClicked = _pageTitleProps$onCli === void 0 ? function () {} : _pageTitleProps$onCli;
      var _locationSelectorProp = locationSelectorProps.listItems,
          locationSelectorListItems = _locationSelectorProp === void 0 ? [] : _locationSelectorProp,
          _locationSelectorProp2 = locationSelectorProps.locationAvatarValue,
          locationAvatarValue = _locationSelectorProp2 === void 0 ? '' : _locationSelectorProp2;
      var avatarValue = userMenuProps.avatarValue,
          _userMenuProps$avatar = userMenuProps.avatarIcon,
          avatarIcon = _userMenuProps$avatar === void 0 ? /*#__PURE__*/React.createElement(UserOutlined, null) : _userMenuProps$avatar;
      var _messageMenuProps$mes = messageMenuProps.messageList,
          messageList = _messageMenuProps$mes === void 0 ? [] : _messageMenuProps$mes; // This is used to set specific className on AppBar outer Div. Then later in css we use this class name to conditionally hide/view things.
      // 			- By the way MobileMenu content it-self is rendered on 'SideBar'. In here we change only AppBar related changes.

      var isMobileMenuViewed = (isMobileViewport || isMobileDevice) && isMobileMenuOpen;
      return /*#__PURE__*/React.createElement("div", {
        className: "AppBar ".concat(isMobileMenuViewed ? 'AppBar--mobileMenuOpen' : 'AppBar--mobileMenuClose')
      }, /*#__PURE__*/React.createElement(AppChangeModal, {
        modalProps: {
          title: 'Select App You Want Go',
          centered: true,
          footer: null,
          visible: isAppChangeModalVisible,
          onOk: function onOk() {
            return _this2.toggleAppChangeModal();
          },
          onCancel: function onCancel() {
            return _this2.toggleAppChangeModal();
          }
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "AppBar____left"
      }, /*#__PURE__*/React.createElement("div", {
        className: "AppBar__title"
      }, /*#__PURE__*/React.createElement("div", {
        className: "AppBar__title___logoAndTextWrapper"
      }, /*#__PURE__*/React.createElement("div", {
        onClick: function onClick() {
          return onAppTitleSectionClicked();
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "AppBar__title__logo",
        style: {
          backgroundImage: "url('".concat(appLogoUrl, "')")
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "AppBar__title__text"
      }, /*#__PURE__*/React.createElement("div", {
        className: "AppBar__title__text__mainTitle"
      }, appTitle), /*#__PURE__*/React.createElement("div", {
        className: "AppBar__title__text__subTitle"
      }, appSubtitle)))), !isMobileDevice && /*#__PURE__*/React.createElement("div", {
        className: "AppBar__title__changeAppBtn",
        onClick: function onClick() {
          return _this2.toggleAppChangeModal();
        }
      }, /*#__PURE__*/React.createElement(SyncOutlined, null))), /*#__PURE__*/React.createElement("div", {
        className: "AppBar__mobileMenu"
      }, /*#__PURE__*/React.createElement(MenuOutlined, {
        onClick: function onClick() {
          toggleMobileMenu();
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "AppBar____middle"
      }, /*#__PURE__*/React.createElement("div", {
        className: "AppBar__pageDetails",
        onClick: function onClick() {
          return onPageTitleSectionClicked();
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "AppBar__pageDetails__mainTitle"
      }, pageTitle), /*#__PURE__*/React.createElement("div", {
        className: "AppBar__pageDetails__subTitle"
      }, pageSubtitle)), /*#__PURE__*/React.createElement("div", {
        className: "AppBar__locationSelector"
      }, locationSelectorListItems.length > 0 && /*#__PURE__*/React.createElement(Dropdown, {
        overlay: /*#__PURE__*/React.createElement(LocationSelectorMenu, {
          listItems: locationSelectorListItems
        }),
        trigger: ['click']
      }, /*#__PURE__*/React.createElement("div", {
        className: "AppBar__locationSelector__trigger",
        title: "Location Selector"
      }, /*#__PURE__*/React.createElement(Avatar, {
        icon: locationAvatarValue ? null : /*#__PURE__*/React.createElement(ShopOutlined, {
          style: {
            color: 'white'
          }
        })
      }, locationAvatarValue), /*#__PURE__*/React.createElement(CaretDownOutlined, null))))), /*#__PURE__*/React.createElement("div", {
        className: "AppBar____right"
      }, /*#__PURE__*/React.createElement("div", {
        className: "AppBar__search"
      }, /*#__PURE__*/React.createElement(SearchBox, null)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Dropdown, {
        overlay: /*#__PURE__*/React.createElement(MessagesMenu, messageMenuProps),
        trigger: ['click']
      }, /*#__PURE__*/React.createElement(Badge, {
        count: messageList.length,
        size: "large"
      }, /*#__PURE__*/React.createElement(MessageOutlined, null)))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Dropdown, {
        overlay: /*#__PURE__*/React.createElement(SettingsMenu, settingsMenuProps),
        trigger: ['click']
      }, /*#__PURE__*/React.createElement(SettingOutlined, null))), /*#__PURE__*/React.createElement("div", {
        className: "AppBar__avatar"
      }, /*#__PURE__*/React.createElement(Dropdown, {
        overlay: /*#__PURE__*/React.createElement(UserMenu, userMenuProps),
        trigger: ['click']
      }, avatarValue ? /*#__PURE__*/React.createElement(Avatar, null, avatarValue) : /*#__PURE__*/React.createElement(Avatar, {
        icon: avatarIcon
      })))));
    }
  }]);

  return AppBar;
}(React.Component);
AppBar.displayName = 'AppBar';

/**
 * This component is used to update direct breadcrumb inside <DashboardLayout.MainContent/> through context.
 * This component itself doesn't render anything. It just update relevant context value, so <DashboardLayout.MainContent/> will show that.
 * This is created as helper component, So user can set DashboardLayout's Breadcrumb value from anywhere in nested components with ease.
 * Note that for this component to be used user must wrap their <App/> with our <EcouiProvider> component. Similar to ReactRouter.
 */

var ConnectedBreadcrumb = /*#__PURE__*/function (_Component) {
  _inherits(ConnectedBreadcrumb, _Component);

  var _super = _createSuper(ConnectedBreadcrumb);

  function ConnectedBreadcrumb() {
    _classCallCheck(this, ConnectedBreadcrumb);

    return _super.apply(this, arguments);
  }

  _createClass(ConnectedBreadcrumb, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var contextActions = this.context.contextActions;
      var updateDashboardLayoutBreadcrumbRoutes = contextActions.updateDashboardLayoutBreadcrumbRoutes;
      var _this$props$breadcrum = this.props.breadcrumbRoutes,
          breadcrumbRoutes = _this$props$breadcrum === void 0 ? [] : _this$props$breadcrum;
      updateDashboardLayoutBreadcrumbRoutes(breadcrumbRoutes);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var contextActions = this.context.contextActions;
      var updateDashboardLayoutBreadcrumbRoutes = contextActions.updateDashboardLayoutBreadcrumbRoutes;
      updateDashboardLayoutBreadcrumbRoutes([]);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return ConnectedBreadcrumb;
}(Component);
ConnectedBreadcrumb.contextType = EcouiContext;

// Using as a functional component, Because we need to use "useRef" hook.

function AllBreadcrumbItems() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$breadcrumbRout = props.breadcrumbRoutes,
      breadcrumbRoutes = _props$breadcrumbRout === void 0 ? [] : _props$breadcrumbRout; // Using Ref to simulate click of TextLink('Breadcrumb__item__link') even when clicked on anywhere of that breadcrumb.

  var myLinkRef = useRef();
  var noOfRoutes = breadcrumbRoutes.length;
  return breadcrumbRoutes.map(function (route, routeIndex) {
    var isLastItem = routeIndex === noOfRoutes - 1;
    return /*#__PURE__*/React.createElement(Breadcrumb$1.Item, {
      key: routeIndex
    }, /*#__PURE__*/React.createElement("span", {
      className: "Breadcrumb__item ".concat(isLastItem ? 'Breadcrumb__item--last' : ''),
      onClick: function onClick() {
        var elem = myLinkRef.current && myLinkRef.current.querySelector('a');

        if (elem) {
          elem.click();
        }
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "Breadcrumb__item__icon"
    }, route.breadcrumbIcon), /*#__PURE__*/React.createElement("span", {
      className: "Breadcrumb__item__link",
      ref: myLinkRef
    }, route.breadcrumbName)));
  });
}

var Breadcrumb = /*#__PURE__*/function (_Component) {
  _inherits(Breadcrumb, _Component);

  var _super = _createSuper(Breadcrumb);

  function Breadcrumb() {
    _classCallCheck(this, Breadcrumb);

    return _super.apply(this, arguments);
  }

  _createClass(Breadcrumb, [{
    key: "render",
    value: function render() {
      var _this$props$breadcrum = this.props.breadcrumbRoutes,
          breadcrumbRoutes = _this$props$breadcrum === void 0 ? [] : _this$props$breadcrum;
      return /*#__PURE__*/React.createElement("div", {
        className: "Breadcrumb"
      }, /*#__PURE__*/React.createElement(Breadcrumb$1, null, /*#__PURE__*/React.createElement(AllBreadcrumbItems, {
        breadcrumbRoutes: breadcrumbRoutes
      })));
    }
  }]);

  return Breadcrumb;
}(Component);
Breadcrumb.displayName = 'Breadcrumb';

var MainContent = /*#__PURE__*/function (_Component) {
  _inherits(MainContent, _Component);

  var _super = _createSuper(MainContent);

  function MainContent() {
    _classCallCheck(this, MainContent);

    return _super.apply(this, arguments);
  }

  _createClass(MainContent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$breadcrum = _this$props.breadcrumbProps,
          breadcrumbProps = _this$props$breadcrum === void 0 ? {} : _this$props$breadcrum,
          children = _this$props.children,
          isMobileMenuOpen = _this$props.isMobileMenuOpen,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          _this$props$contentCo = _this$props.contentContainerStyle,
          contentContainerStyle = _this$props$contentCo === void 0 ? {} : _this$props$contentCo;
      var breadcrumbRoutes = breadcrumbProps.breadcrumbRoutes; // Directly passed Breadcrumb Routes to <MainContent> itself. This take precedence if provided.
      // If "breadcrumbRoutes" stetted on context somehow, extracting it.(Ex. Using <DashboardLayout.ConnectedBreadcrumb/>)

      var contextState = this.context.contextState;
      var _contextState$dashboa = contextState.dashboardLayoutBreadcrumbRoutes,
          dashboardLayoutBreadcrumbRoutes = _contextState$dashboa === void 0 ? [] : _contextState$dashboa;
      var breadcrumbs = breadcrumbRoutes || dashboardLayoutBreadcrumbRoutes;
      return /*#__PURE__*/React.createElement("div", {
        className: "MainContent",
        style: _objectSpread2({
          // NOTE : Tweak to Making Content don't exceed viewport width when mobile menu is open. (Content is hidden behind menu anyway)
          // 				Because, Then Mobile menu won't take unnecessary height, which hide UI ugliness.
          maxHeight: isMobileMenuOpen ? 'calc(100vh - var(--appBarHeight)' : 'initial'
        }, style)
      }, breadcrumbs.length > 0 && /*#__PURE__*/React.createElement(Breadcrumb, {
        breadcrumbRoutes: breadcrumbs
      }), /*#__PURE__*/React.createElement("div", {
        className: "MainContent__content",
        style: contentContainerStyle
      }, children));
    }
  }]);

  return MainContent;
}(Component);
MainContent.contextType = EcouiContext;
MainContent.displayName = 'MainContent';

var SubMenu = Menu.SubMenu;

var SideBar = /*#__PURE__*/function (_React$Component) {
  _inherits(SideBar, _React$Component);

  var _super = _createSuper(SideBar);

  function SideBar(props) {
    var _this;

    _classCallCheck(this, SideBar);

    _this = _super.call(this, props);
    _this.state = {
      // Below state are used with "TwoFold Menu" Type. (Specifically when "isTwoFoldMenu" is True)
      shouldTwoFoldAdditionalSectionVisible: false,
      // Track whether clicked "subGroupMenu" item has Sub Menus and should show them in Two Fold Additional Section.
      selectedSubGroupPath: '',
      // Should be lodash.get() friendly path. This is used to track user clicked the same Sub Group Menu Item or not.
      selectedSubGroupData: '' // SubMenu Items list for above selected Group Item Path.

    };
    return _this;
  } // Helper function to handle Main Menu Items clicks when "isTwoFold" is True.


  _createClass(SideBar, [{
    key: "handleTwoFoldMenuItemClick",
    value: function handleTwoFoldMenuItemClick() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$state = this.state,
          shouldTwoFoldAdditionalSectionVisible = _this$state.shouldTwoFoldAdditionalSectionVisible,
          prevSelectedSubGroupPath = _this$state.selectedSubGroupPath;
      var newlySelectedSubGroupPath = data.selectedSubGroupPath,
          _data$selectedSubGrou = data.selectedSubGroupMenuData,
          selectedSubGroupMenuData = _data$selectedSubGrou === void 0 ? {} : _data$selectedSubGrou; // In here we handle showing "Two Fold" additional section visibility.

      var visibleState = shouldTwoFoldAdditionalSectionVisible;

      if (!selectedSubGroupMenuData.isSubMenu) {
        // When don't have any sub menu to show.
        visibleState = false;
      } else if (newlySelectedSubGroupPath === prevSelectedSubGroupPath) {
        // When clicked on same item already clicked.
        // This give the user ability to toggle  additional menu part visibility.
        visibleState = !visibleState;
      } else {
        // Initial click on a menu that has sub menus.
        visibleState = true;
      }

      this.setState({
        shouldTwoFoldAdditionalSectionVisible: visibleState,
        selectedSubGroupPath: newlySelectedSubGroupPath,
        selectedSubGroupData: selectedSubGroupMenuData
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state2 = this.state,
          shouldTwoFoldAdditionalSectionVisible = _this$state2.shouldTwoFoldAdditionalSectionVisible,
          selectedSubGroupData = _this$state2.selectedSubGroupData;
      var _this$props = this.props,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          _this$props$isMobileM = _this$props.isMobileMenuOpen,
          isMobileMenuOpen = _this$props$isMobileM === void 0 ? false : _this$props$isMobileM,
          _this$props$isMobileV = _this$props.isMobileViewport,
          isMobileViewport = _this$props$isMobileV === void 0 ? false : _this$props$isMobileV,
          _this$props$isMobileD = _this$props.isMobileDevice,
          isMobileDevice = _this$props$isMobileD === void 0 ? false : _this$props$isMobileD,
          _this$props$toggleMob = _this$props.toggleMobileMenu,
          toggleMobileMenu = _this$props$toggleMob === void 0 ? function () {} : _this$props$toggleMob,
          _this$props$currentVi = _this$props.currentViewportSizes,
          currentViewportSizes = _this$props$currentVi === void 0 ? {} : _this$props$currentVi,
          _this$props$mainMenuP = _this$props.mainMenuProps,
          mainMenuProps = _this$props$mainMenuP === void 0 ? {} : _this$props$mainMenuP;
      var _mainMenuProps$menuCo = mainMenuProps.menuConfig,
          menuConfig = _mainMenuProps$menuCo === void 0 ? [] : _mainMenuProps$menuCo;
      var _currentViewportSizes = currentViewportSizes.innerWidth,
          innerWidth = _currentViewportSizes === void 0 ? 1000 : _currentViewportSizes; // These are used to set mobile/small-res specific changes. (Ex. like making menu inline or vertical)
      // 		- By the way if its a "isMobileDevice: true" we show Mobile Menu regardless of current resolution.

      var hideMobileMenu = (isMobileViewport || isMobileDevice) && !isMobileMenuOpen;
      var isElasticMenu = !isMobileDevice && innerWidth >= 768 && innerWidth <= 1024;

      var isTwoFoldMenu = !isMobileDevice && innerWidth >= 1024; // Showing TwoFold Menu (Kind of showing another section when more sub menus are available.) for Higher Resolutions.

      return /*#__PURE__*/React.createElement("div", {
        className: "\n\t\t\t\t\tSideBar\n\t\t\t\t\t".concat(className, "\n\t\t\t\t\t").concat(isElasticMenu ? 'SideBar--elasticMenu' : '', "\n\t\t\t\t\t").concat(hideMobileMenu ? 'ECOUI-UTL-hidden' : '', "\n\t\t\t\t\t").concat(isTwoFoldMenu ? 'SideBar--twoFoldMenu' : '', "\n\t\t\t\t")
      }, /*#__PURE__*/React.createElement("div", {
        className: "SideBar_____menuWrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "SideBar__menu"
      }, /*#__PURE__*/React.createElement(Menu, {
        onClick: function onClick() {
          return toggleMobileMenu();
        },
        mode: 'inline' 
      }, menuConfig.map(function (menuGroup, menuGroupIndex) {
        return /*#__PURE__*/React.createElement(Menu.ItemGroup, {
          key: menuGroupIndex // NOTE: If menuGroupTitle not provided we render <hr/> to indicate division of menu.
          //       But if you don't want either menuGroupTitle or <hr/>, Pass empty string for 'menuGroupTitle' as trick.
          ,
          title: menuGroup.menuGroupTitle || /*#__PURE__*/React.createElement("hr", null)
        }, menuGroup.groupEntries.map(function (groupEntries, subGroupIndex) {
          // Iterating through group's each individual MenuItems.
          return groupEntries.menuItems.map(function (menu, menuIndex) {
            var isSubMenu = menu.isSubMenu;
            /**
             * SIDENOTE : Some abbreviation meaning used in key names.
             * 					  Having these distinction key name is important, Otherwise some hard to track error occurs. (Ex. Menu with same key opening when only clicked on one menu.)
             * 		- L1G : Level 1 Group
             * 		- L2G : Level 2 Group
             * 			.......
             * 		- L3M : Level 3 Menu
             * 		- L4M : Level 4 Menu
             * 			.......
             */
            // ****** Only Applicable when "Two Fold Menu" Activated.
            // NOTE : This part only render Menu Icons for Main Level Menu Items. Once click on a one of this Menu Item. additional Menu Items will be shown in separate " SideBar__additionalMenu" area. (If applicable)
            // SIDE NOTE : By the way "Two Fold Menu" is introduced to  the codebase much later.

            if (isTwoFoldMenu) {
              return /*#__PURE__*/React.createElement(Menu.Item, {
                id: "L1G".concat(menuGroupIndex, "-L2G").concat(subGroupIndex),
                key: "L1G".concat(menuGroupIndex, "-L2G").concat(subGroupIndex),
                icon: menu.menuIcon,
                onClick: function onClick() {
                  _this2.handleTwoFoldMenuItemClick({
                    selectedSubGroupPath: "[".concat(menuGroupIndex, "].groupEntries[").concat(subGroupIndex, "].menuItems[").concat(menuIndex, "]"),
                    selectedSubGroupMenuData: menu
                  }); // NOTE : Normally on "TwoFold Menu" variant we are not showing MenuTitle text. Only showing Icon for Root Level items.
                  // 				So in here we manually invoke "menuTitle Link" if available when clicked on the Icon. So items without ant sub menu items also work properly.


                  var menuTitleLink = document.querySelector("#L1G".concat(menuGroupIndex, "-L2G").concat(subGroupIndex, " .SideBar__menu__menuItem a"));

                  if (menuTitleLink) {
                    menuTitleLink.click();
                  }

                  if (_isFunction(menu.onClick)) {
                    menu.onClick();
                  }
                }
              }, /*#__PURE__*/React.createElement("div", {
                className: "SideBar__menu__menuItem"
              }, menu.menuTitle));
            } // ****** Only Applicable when "Elastic Menu / Normal / Mobile Menu" Activated.


            if (isSubMenu) {
              // When SubMenu is Available.
              // TODO : Need to introduce, Recursive Function to handle nested menu items.
              return /*#__PURE__*/React.createElement(SubMenu, {
                key: "L1G".concat(menuGroupIndex, "-L2G").concat(subGroupIndex),
                icon: menu.menuIcon,
                title: menu.menuTitle,
                popupClassName: "SideBar__popups"
              }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
                className: "SideBar__popups__header"
              }, /*#__PURE__*/React.createElement("div", null, menu.menuTitle)), menu.subMenuItems.map(function (subMenuL1, subMenuL1Index) {
                var isNestedSubMenuAvailable = subMenuL1.isSubMenu;

                if (isNestedSubMenuAvailable) {
                  return /*#__PURE__*/React.createElement(SubMenu, {
                    key: "L1G".concat(menuGroupIndex, "-L2G").concat(subGroupIndex, "-L3G").concat(subMenuL1Index),
                    icon: subMenuL1.menuIcon,
                    title: subMenuL1.menuTitle,
                    popupClassName: "SideBar__popups"
                  }, subMenuL1.subMenuItems.map(function (subMenuL2, subMenuL2Index) {
                    return /*#__PURE__*/React.createElement(Menu.Item, {
                      key: "L1G".concat(menuGroupIndex, "-L2G").concat(subGroupIndex, "-L3G").concat(subMenuL1Index, "-L4M").concat(subMenuL2Index),
                      icon: subMenuL2.menuIcon,
                      onClick: subMenuL2.onClick
                    }, subMenuL2.menuTitle);
                  }));
                } else {
                  return /*#__PURE__*/React.createElement(Menu.Item, {
                    key: "L1G".concat(menuGroupIndex, "-L2G").concat(subGroupIndex, "-L3M").concat(subMenuL1Index),
                    icon: subMenuL1.menuIcon,
                    onClick: subMenuL1.onClick
                  }, /*#__PURE__*/React.createElement("div", {
                    className: "SideBar__menu__menuItem"
                  }, subMenuL1.menuTitle));
                }
              }), /*#__PURE__*/React.createElement("div", {
                className: "SideBar__popups__iconBackground"
              }, /*#__PURE__*/React.createElement("div", null, menu.menuIcon))));
            } else {
              // If don't contain SubMenu.
              return /*#__PURE__*/React.createElement(Menu.Item, {
                key: "L1G".concat(menuGroupIndex, "-L2M").concat(subGroupIndex),
                icon: menu.menuIcon,
                onClick: menu.onClick
              }, /*#__PURE__*/React.createElement("div", {
                className: "SideBar__menu__menuItem"
              }, menu.menuTitle));
            }
          });
        }));
      }))), isTwoFoldMenu && shouldTwoFoldAdditionalSectionVisible && /*#__PURE__*/React.createElement("div", {
        className: "SideBar__additionalMenu"
      }, /*#__PURE__*/React.createElement("div", {
        className: "SideBar__additionalMenu__title"
      }, selectedSubGroupData.menuTitle), selectedSubGroupData.subMenuItems.map(function (subMenu, subMenuIndex) {
        var isNestedSubMenuAvailable = subMenu.isSubMenu;
        return /*#__PURE__*/React.createElement("div", {
          key: "SideBar__additionalMenu".concat(subMenuIndex)
        }, /*#__PURE__*/React.createElement("div", {
          className: "SideBar__additionalMenu__subMenuContainer SideBar__additionalMenu__subMenuContainer_L1"
        }, /*#__PURE__*/React.createElement("div", {
          className: "SideBar__additionalMenu__subMenuContainer__title"
        }, /*#__PURE__*/React.createElement("span", null, subMenu.menuIcon), /*#__PURE__*/React.createElement("span", null, subMenu.menuTitle)), isNestedSubMenuAvailable && subMenu.subMenuItems.map(function (subMenuL2, subMenuL2Index) {
          return /*#__PURE__*/React.createElement("div", {
            className: "SideBar__additionalMenu__subMenuContainer SideBar__additionalMenu__subMenuContainer_L2",
            key: "SideBar__additionalMenu".concat(subMenuIndex, "-").concat(subMenuL2Index)
          }, /*#__PURE__*/React.createElement("div", {
            className: "SideBar__additionalMenu__subMenuContainer__title"
          }, /*#__PURE__*/React.createElement("span", null, subMenuL2.menuIcon), /*#__PURE__*/React.createElement("span", null, subMenuL2.menuTitle)));
        })));
      }))));
    }
  }]);

  return SideBar;
}(React.Component);
SideBar.displayName = 'SideBar';

var userAgentDetails = deviceDetectionUtils.userAgentDetails;
var isMobileDevice = userAgentDetails.isMobileDevice;

var DashboardLayout = /*#__PURE__*/function (_Component) {
  _inherits(DashboardLayout, _Component);

  var _super = _createSuper(DashboardLayout);

  function DashboardLayout(props) {
    var _this;

    _classCallCheck(this, DashboardLayout);

    _this = _super.call(this, props);
    _this.state = {
      isMobileMenuOpen: false,
      isMobileViewport: false,
      currentViewportSizes: {}
    }; // Binding, Memoizing, De-bouncing relevant functions.

    _this.findCompInstanceByDisplayName = memoize(_this.findCompInstanceByDisplayName.bind(_assertThisInitialized(_this)), {
      length: 2
    });
    _this.onWindowResize = _debounce(_this.onWindowResize, 200);
    return _this;
  }

  _createClass(DashboardLayout, [{
    key: "toggleMobileMenu",
    value: function toggleMobileMenu() {
      var _this$state = this.state,
          isMobileViewport = _this$state.isMobileViewport,
          isMobileMenuOpen = _this$state.isMobileMenuOpen;

      if (isMobileViewport || isMobileDevice) {
        this.setState({
          isMobileMenuOpen: !isMobileMenuOpen
        });
      }
    }
  }, {
    key: "getCurrentViewportSizes",
    value: function getCurrentViewportSizes() {
      return {
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      };
    }
  }, {
    key: "getViewportBreakpointSize",
    value: function getViewportBreakpointSize() {
      var viewportWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var breakpoint = '';

      switch (true) {
        case viewportWidth <= 576:
          {
            breakpoint = 'xs';
            break;
          }

        case viewportWidth <= 768:
          {
            breakpoint = 'sm';
            break;
          }

        case viewportWidth <= 992:
          {
            breakpoint = 'md';
            break;
          }

        case viewportWidth <= 1200:
          {
            breakpoint = 'lg';
            break;
          }

        case viewportWidth <= 1600:
          {
            breakpoint = 'xl';
            break;
          }

        default:
          {
            breakpoint = 'xxl';
            break;
          }
      }

      return breakpoint;
    } // Utility fn. to handle things when Browser Window Get Resized.
    // NOTE : This fn is "_debounced" on constructor to avoid unnecessary frequent state updates.

  }, {
    key: "onWindowResize",
    value: function onWindowResize() {
      var _this$props$getViewpo = this.props.getViewportChanges,
          getViewportChanges = _this$props$getViewpo === void 0 ? function ()
      /* ViewportValues Will Be Passed Here */
      {} : _this$props$getViewpo;
      var contextActions = this.context.contextActions;
      var updateCurrentViewportData = contextActions.updateCurrentViewportData;
      var currentViewportSizes = this.getCurrentViewportSizes();
      var isMobileViewport = currentViewportSizes.innerWidth <= 768;
      var viewportAsBreakpoint = this.getViewportBreakpointSize(currentViewportSizes.innerWidth);
      /**
       * ADDON NOTE : In here we have made, multiple ways to access our internal Viewport data by other our-own other components and also by end-user.
       * 							Those ways are
       * 									1. By passing "getViewportChanges" to <DashboardLayout/>
       * 									2. Using 'withViewportData()' HOC
       * 									3. Directly consuming Context through "<EcouiConsumer>" OR "withEcouiContext()' HOC.
       */

      var viewportDataToBeAccessed = {
        currentViewportSizes: currentViewportSizes,
        currentBreakpoint: viewportAsBreakpoint,
        isMobileViewport: isMobileViewport
      }; // Passing data to user passed function. (If Applicable)

      if (_isFunction(getViewportChanges)) {
        getViewportChanges(viewportDataToBeAccessed);
      } // Passing data to context consumer so user can also get this details through Context if needed.


      updateCurrentViewportData(viewportDataToBeAccessed);
      this.setState({
        currentViewportSizes: currentViewportSizes,
        isMobileViewport: isMobileViewport,
        isMobileMenuOpen: false // Closing Mobile Menu.

      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('resize', function () {
        return _this2.onWindowResize();
      });
      this.onWindowResize(); // Firing once on 'componentDidMount' to setup initial values on react state.
    } // This utility function is used to extract specific related Component (Ex. AppBar, SideBar, ....) Instance passed to 'DashboardLayout' as child. Also this is combinelly used with "getChildCompWithAdditionalProps()"
    // This is needed because we don't care which order specific related Components are passed. We just extract if it is passed and later render on specific container.
    // So 'DashboardLayout' will have specific structure.
    //
    // NOTE : This function is "Memoized" in constructor for avoid unnecessary "React.cloneElement" which result in re-mounting.

  }, {
    key: "findCompInstanceByDisplayName",
    value: function findCompInstanceByDisplayName() {
      var compDisplayName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var childrenCompList = [];

      if (Array.isArray(children)) {
        // Handling multiple children being passed.
        childrenCompList = children;
      } else if (_typeof(children) === 'object') {
        // Handling single child being passed.
        childrenCompList.push(children);
      } // Extracting relevant component from passed children list as ReactElement. (If available.)


      return childrenCompList.find(function (child) {
        return child.type && child.type.displayName === compDisplayName;
      });
    }
  }, {
    key: "getChildCompWithAdditionalProps",
    value: function getChildCompWithAdditionalProps() {
      var childCompDisplayName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var children = this.props.children; // Getting needed component as ReactElement from passed children list.

      var compElem = this.findCompInstanceByDisplayName(childCompDisplayName, children); // In case relevant child is not found retuning null element to avoid errors and render nothing.

      if (!compElem) {
        return null;
      } // Specified Component is found from children list passed by user. So we clone it with additional props here and later render it.


      return /*#__PURE__*/React.cloneElement(compElem, props);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state2 = this.state,
          isMobileMenuOpen = _this$state2.isMobileMenuOpen,
          isMobileViewport = _this$state2.isMobileViewport,
          currentViewportSizes = _this$state2.currentViewportSizes;
      var _this$props$loaderPro = this.props.loaderProps,
          loaderProps = _this$props$loaderPro === void 0 ? {} : _this$props$loaderPro;
      var isLoading = loaderProps.isLoading,
          isError = loaderProps.isError,
          _loaderProps$showDash = loaderProps.showDashboard,
          showDashboard = _loaderProps$showDash === void 0 ? true : _loaderProps$showDash,
          appLogoUrl = loaderProps.appLogoUrl,
          errorMsg = loaderProps.errorMsg,
          _loaderProps$onErrorT = loaderProps.onErrorTryAgainFn,
          onErrorTryAgainFn = _loaderProps$onErrorT === void 0 ? function () {} : _loaderProps$onErrorT; // Extracting these specific Components, if they are passed as children's.

      var AppBarComp = this.getChildCompWithAdditionalProps('AppBar', {
        isMobileViewport: isMobileViewport,
        isMobileDevice: isMobileDevice,
        isMobileMenuOpen: isMobileMenuOpen,
        toggleMobileMenu: function toggleMobileMenu() {
          return _this3.toggleMobileMenu();
        }
      });
      var SideBarComp = this.getChildCompWithAdditionalProps('SideBar', {
        isMobileViewport: isMobileViewport,
        isMobileDevice: isMobileDevice,
        isMobileMenuOpen: isMobileMenuOpen,
        currentViewportSizes: currentViewportSizes,
        toggleMobileMenu: function toggleMobileMenu() {
          return _this3.toggleMobileMenu();
        }
      });
      var MainContentComp = this.getChildCompWithAdditionalProps('MainContent', {
        isMobileViewport: isMobileViewport,
        isMobileDevice: isMobileDevice,
        isMobileMenuOpen: isMobileMenuOpen,
        currentViewportSizes: currentViewportSizes,
        toggleMobileMenu: function toggleMobileMenu() {
          return _this3.toggleMobileMenu();
        }
      });

      if (isLoading || isError || !showDashboard) {
        return /*#__PURE__*/React.createElement("div", {
          className: "DashboardLayout"
        }, /*#__PURE__*/React.createElement(LoaderView, {
          isLoading: isLoading,
          isError: isError,
          typeConfigs: {
            loading: {
              icon: appLogoUrl ? /*#__PURE__*/React.createElement("img", {
                alt: "",
                src: appLogoUrl
              }) : /*#__PURE__*/React.createElement(Spin, null),
              extra: appLogoUrl ? /*#__PURE__*/React.createElement(Spin, null) : ''
            },
            error: {
              icon: appLogoUrl ? /*#__PURE__*/React.createElement("img", {
                alt: "",
                src: appLogoUrl
              }) : /*#__PURE__*/React.createElement(CloseCircleFilled, null),
              subTitle: errorMsg || 'Error Occurred. Please Try Again.',
              extra: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
                type: "primary",
                onClick: function onClick() {
                  onErrorTryAgainFn();
                }
              }, "TRY AGAIN"))
            }
          }
        }));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "DashboardLayout"
      }, /*#__PURE__*/React.createElement("div", {
        className: "DashboardLayout__header"
      }, AppBarComp), /*#__PURE__*/React.createElement("div", {
        className: "DashboardLayout__body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "DashboardLayout__body__sideBar"
      }, SideBarComp), /*#__PURE__*/React.createElement("div", {
        className: "DashboardLayout__body__mainContent"
      }, MainContentComp)));
    }
  }]);

  return DashboardLayout;
}(Component);

DashboardLayout.contextType = EcouiContext; // Adding dot-notation react component reference. (Ex. <DashboardLayout.AppBar>)

DashboardLayout.AppBar = AppBar;
DashboardLayout.SideBar = SideBar;
DashboardLayout.MainContent = MainContent;
DashboardLayout.ConnectedBreadcrumb = ConnectedBreadcrumb;

var Table = /*#__PURE__*/function (_Component) {
  _inherits(Table, _Component);

  var _super = _createSuper(Table);

  function Table() {
    _classCallCheck(this, Table);

    return _super.apply(this, arguments);
  }

  _createClass(Table, [{
    key: "getAntdTableProps",
    value: // This function return all the props we need to pass to <AntdTable/> considering all dynamic logics.
    function getAntdTableProps() {
      var _this$props$customPro = this.props.customProps,
          customProps = _this$props$customPro === void 0 ? {} : _this$props$customPro; // We are using 'customProps' to handle additional features top-of AntD Table.

      var _customProps$showCard = customProps.showCardViewInMobileRes,
          showCardViewInMobileRes = _customProps$showCard === void 0 ? false : _customProps$showCard; // Our custom set of default values for AntD Table.

      var antdTableDefaultProps = {
        bordered: false,
        columns: [],
        dataSource: [],
        size: 'medium',
        scroll: {
          x: 'max-content' // Need to explore more. But unless this is set to 'max-content' setting manual width on column later seems lot harder.

        },
        pagination: {
          size: 'small',
          pageSize: 10,
          hideOnSinglePage: true,
          showSizeChanger: false // Disabling automatically showing size changer.

        }
      }; // Getting only "Passed AntD Specific Props" by removing our 'customProps' key.

      var antdTablePassedProps = _omitObjKeys(this.props, ['customProps']); // This is combination of props (Our Default Props + Passed AntD Specific Props). Before any custom dynamic changes.
      // Values in here will be used to make most of the dynamic decisions.


      var antdTablePreDynamicProps = objDeepMixin(antdTableDefaultProps, antdTablePassedProps); // NOTE : In various positions in code, this will be updated accordingly. This will contain customized AntD Table props witch calculated from dynamic logic.

      var antdTableDynamicProps = {}; // Dynamic Changes according to "Custom Props".
      // ----> "showCardViewInMobileRes" Prop. This prop can be used to show row tables as cards in smaller resolution. Useful to show larger column tables in smaller resolution.

      if (showCardViewInMobileRes) {
        // In here we customize existing column list by passing custom 'onCell' handler. This will add column title value as 'data-trLabel' to each <td> markup.
        // So later with CSS we can use that value to show in card view. (This is done with special CSS class. Check 'specialTableCustomizationClasses' variable below. Specifically 'ECOUI-Table--cardView' class.)
        var moddedColumnList = antdTablePreDynamicProps.columns.map(function (columnConfig) {
          return _objectSpread2(_objectSpread2({}, columnConfig), {}, {
            onCell: function onCell() {
              // If user passed specific 'onCell' function we are invoking it to get its config and pass with ours.
              var originalOnCellConfig = _isFunction(columnConfig.onCell) ? columnConfig.onCell() : {};
              return _objectSpread2(_objectSpread2({}, originalOnCellConfig), {}, {
                'data-label': columnConfig.title // Adding attribute as 'data-label'

              });
            }
          });
        });
        antdTableDynamicProps = _objectSpread2(_objectSpread2({}, antdTableDynamicProps), {}, {
          columns: moddedColumnList
        });
      } // This is final prop list we directly pass to <AntdTable/>.


      return objDeepMixin(antdTablePreDynamicProps, antdTableDynamicProps);
    }
  }, {
    key: "getDynamicClassSets",
    value: function getDynamicClassSets() {
      var _this$props$customPro2 = this.props.customProps,
          customProps = _this$props$customPro2 === void 0 ? {} : _this$props$customPro2; // We are using 'customProps' to handle additional features top-of AntD Table.

      var _customProps$showCard2 = customProps.showCardViewInMobileRes,
          showCardViewInMobileRes = _customProps$showCard2 === void 0 ? false : _customProps$showCard2; // These are the our custom changer classes that overrides default AntD Table styles to match our preference, special cases, etc...

      /*  Available Variations -->
      			- ECOUI-Table--defaultTheme	: Look like stylistic, But normal table.
      			- ECOUI-Table--separateItemTheme : More stylistic, Each row is look separated.
      */

      var tableThemeClass = 'ECOUI-Table--separateItemTheme';
      /*  Available Variations -->
      			- ECOUI-Table--cardView	: This make, In smaller resolutions each row become card view. So for large tables, we can use this for give user best experience in smaller resolutions.
      */

      var specialTableCustomizationClasses = "".concat(showCardViewInMobileRes ? 'ECOUI-Table--cardView' : '');
      return {
        tableThemeClass: tableThemeClass,
        specialTableCustomizationClasses: specialTableCustomizationClasses
      };
    }
  }, {
    key: "render",
    value: function render() {
      var antdTableFinalProps = this.getAntdTableProps();

      var _this$getDynamicClass = this.getDynamicClassSets(),
          tableThemeClass = _this$getDynamicClass.tableThemeClass,
          specialTableCustomizationClasses = _this$getDynamicClass.specialTableCustomizationClasses;

      return /*#__PURE__*/React.createElement("div", {
        className: "ECOUI-Table ".concat(tableThemeClass, " ").concat(specialTableCustomizationClasses)
      }, /*#__PURE__*/React.createElement(Table$1, antdTableFinalProps));
    }
  }]);

  return Table;
}(Component);

var _excluded$1 = ["currentViewportData", "innerTitle", "mobileLabel", "children"],
    _excluded2 = ["innerTitle", "children"];

var TimelineIcon = function TimelineIcon(props) {
  var _props$color = props.color,
      color = _props$color === void 0 ? 'gray' : _props$color,
      children = props.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "ECOUI-TimelineIcon",
    style: {
      /* stylelint-disable-line */
      background: color,
      borderRadius: '50%',
      padding: '7px',
      color: 'white',
      fontSize: '1.3rem'
    }
  }, children);
}; // Direct children of <Timeline/> must be these. This is used to render whatever we want to render for each Timeline Entry.

var TimelineItem = function TimelineItem(props) {
  var currentViewportData = props.currentViewportData;
      props.innerTitle;
      var mobileLabel = props.mobileLabel,
      children = props.children,
      antdTimelineCompProps = _objectWithoutProperties(props, _excluded$1);

  var isMobileViewport = currentViewportData.isMobileViewport;
  return /*#__PURE__*/React.createElement("div", {
    className: "ECOUI-TimelineItem"
  }, /*#__PURE__*/React.createElement(Timeline$1.Item, _extends({}, antdTimelineCompProps, {
    dot: /*#__PURE__*/React.createElement(TimelineIcon, {
      color: antdTimelineCompProps.color
    }, antdTimelineCompProps.dot) // NOTE : This label will be hidden on mobile resolution. Logic for that is on <Timeline/> component.
    ,
    label: /*#__PURE__*/React.createElement("div", {
      className: "ECOUI-TimelineItem__label"
    }, antdTimelineCompProps.label)
  }), isMobileViewport && mobileLabel ? /*#__PURE__*/React.createElement("div", {
    className: "ECOUI-TimelineItem__label"
  }, mobileLabel) : '', children));
}; // This can be used inside <TimelineItem/> to give Timeline Entry content a card view.

var TimelineCard = function TimelineCard(props) {
  var innerTitle = props.innerTitle,
      children = props.children,
      antdCardCompProps = _objectWithoutProperties(props, _excluded2);

  return /*#__PURE__*/React.createElement("div", {
    className: "ECOUI-TimelineCard"
  }, /*#__PURE__*/React.createElement(Card, antdCardCompProps, innerTitle && /*#__PURE__*/React.createElement("div", {
    className: "ECOUI-TimelineCard__innerTitle"
  }, innerTitle), children));
};

var _excluded = ["currentViewportData", "children"];

var Timeline = /*#__PURE__*/function (_Component) {
  _inherits(Timeline, _Component);

  var _super = _createSuper(Timeline);

  function Timeline() {
    _classCallCheck(this, Timeline);

    return _super.apply(this, arguments);
  }

  _createClass(Timeline, [{
    key: "getTimelineItemCompsWithAdditionalProps",
    value: // Adding additional props and some conditional prop changes to <Timeline.Item/> child components.
    function getTimelineItemCompsWithAdditionalProps() {
      var _this$props = this.props,
          currentViewportData = _this$props.currentViewportData,
          children = _this$props.children;
      var isMobileViewport = currentViewportData.isMobileViewport;
      var additionalProps = {
        currentViewportData: currentViewportData
      };
      /**
       * NOTE: 	For responsive purposes we are trying to hide "label" part while in mobile resolution, if user specified. (Code related to this mainly handled on <Timeline.Item>)
       *				But for some reason, If 'label' prop is passed, Even if we make it null it later in <Timeline.Item/> component it doesn't work.
       *				So in here we conditionally forcing 'label' prop to be null here.
       * 				Seems very weird bug. Tried to track it a lot, But couldn't.
       */

      if (isMobileViewport) {
        additionalProps.label = null;
      } // Cloning all child element to add additional prop.


      return children.flat().map(function (child, index) {
        if ( /*#__PURE__*/React.isValidElement(child)) {
          return /*#__PURE__*/React.cloneElement(child, _objectSpread2(_objectSpread2({}, additionalProps), {}, {
            key: index
          }));
        }

        return child;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          currentViewportData = _this$props2.currentViewportData;
          _this$props2.children;
          var antdTimelineProps = _objectWithoutProperties(_this$props2, _excluded);

      var isMobileViewport = currentViewportData.isMobileViewport;
      var childrenTimelineItemsWithAdditionalProps = this.getTimelineItemCompsWithAdditionalProps();
      return /*#__PURE__*/React.createElement("div", {
        className: "ECOUI-Timeline"
      }, /*#__PURE__*/React.createElement(Timeline$1, _extends({}, antdTimelineProps, {
        mode: isMobileViewport ? 'left' : antdTimelineProps.mode || 'left'
      }), childrenTimelineItemsWithAdditionalProps));
    }
  }]);

  return Timeline;
}(Component);

var TimelineWithHOC = withViewportData(Timeline); // Helper components to be used inside <Timeline/>.

TimelineWithHOC.Item = TimelineItem; // Direct children of <Timeline/> must be these.

TimelineWithHOC.Card = TimelineCard;

// Temporary function for debugging purposes. Give user ability to check what UIVersion currently using on there project.
function getUiLibraryVersion() {
  return '2021/07/12 01.00 PM IST';
}

export { DashboardLayout, EcouiProvider, HeaderBar, HelloWorld, LoaderView, Table, TimelineWithHOC as Timeline, deviceDetectionUtils as deviceDetection, getUiLibraryVersion, withEcouiContext, withViewportData };
